import update from 'immutability-helper'
import {zip} from 'lodash'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Table from '@mui/material/Table'

import Select from '../Select'

import StatusIcon from '../StatusIcon'

const useStyles = makeStyles(matchingStyles)

export default function Matching ({assessment, context, question}) {

  const classes = useStyles()

  const {translate} = context

  const {answers = {}} = assessment 
  const answer = answers[question.id] || {terms: [], definitions: []}


  const terms = answer.terms.map((term, index) => {

    const value = answer.selected[index]

    const correctIndex = answer.definitions.findIndex (d => d.index == term.index)

    const indexToLetter = index => String.fromCharCode(Math.min(index, 20) + 97)

    const answerIndex = indexToLetter(correctIndex)

    const correct = correctIndex == value

    return (<React.Fragment>
      <TableCell align="left" className={clsx(classes.cell, classes.correctAnswer)} size="small">
        <Box className={clsx(classes.correct, {correct})}>{answerIndex}</Box>
      </TableCell>
      <TableCell align="left" className={clsx(classes.cell, classes.status)} size="small">
        <StatusIcon value={value} answer={value} correctAnswer={correctIndex} />
      </TableCell>
      <TableCell className={clsx(classes.cell, classes.selectAnswer)} size="small">
        <Box className={classes.answer}>
          <Select value={value >= 0 ? indexToLetter(value) : ' '} />
        </Box>
      </TableCell>
      <TableCell className={clsx(classes.cell, classes.termHtml)} dangerouslySetInnerHTML={{__html: term.term || ''}} />
    </React.Fragment>)
  })

  const definitions = answer.definitions.map(({definition}, index) => {
    const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
    return (<React.Fragment>
      <TableCell className={clsx(classes.cell, classes.definitionIndex, {selected: answer.selected.indexOf(index) > -1})} size="small">
        {answerIndex})
      </TableCell>
      <TableCell className={clsx(classes.cell, classes.definitionValue)} dangerouslySetInnerHTML={{__html: definition || ''}} />
    </React.Fragment>)
  })

  return (
  <Box className={classes.root}>
    <TableContainer component={Box} className={classes.tableContainer}>
      <Table className={classes.table}>
        <TableBody>{
          zip(terms, definitions).map(([term, definition], index) => {
            return (
              <TableRow key={index} className={classes.pair}>
                {term}
                {definition}
              </TableRow>
            )
          })}</TableBody>
     </Table>
   </TableContainer>
  </Box>
  )
}

function matchingStyles (theme) {
  return {
    root: {
      display: 'flex',
      marginTop: 10,
      flexGrow: 1
    },
    tableContainer: {
      flexShrink: 0,
      maxWidth: 1280,
      display: 'flex',
      fontSize: '12pt',
    },
    correct: {
      display: 'flex',
      width: 35,
      height: 35,
      borderRadius: '100%',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      color: '#fff',
      backgroundColor: '#0bccd5',
      '&.correct': {
        visibility: 'hidden'
      },

    },
    cell: {
      borderBottom: 0,
      padding: '16px 8px',
      verticalAlign: 'top'
    },
    correctAnswer: {
      width: 35,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 35
    },
    status: {
      width: 30,
      maxWidth: 30,
      flexGrow: 0,
      flexShrink: 0,
      paddingTop: 22 
    },
    selectAnswer: {
      width: 45,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 45
    },
    definitionIndex: {
      width: 20,
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 20
    },
    table: {
      maxWidth: 1280
    },
    term: {
      display: 'flex'
    },
    termHtml: {
      paddingLeft: 20,
      '& > p': {
        margin: 0
      }
    },
    definitionValue: {
      paddingLeft: 20,
      '& > p': {
        margin: 0
      }
    }
  }
}
